export default __webpack_public_path__ + "static/media/expired.aebfaae5.png";